import { Component } from "@angular/core";
import { Router, NavigationEnd, NavigationStart } from "@angular/router";
import { MenuItem } from "primeng/api";
import { filter } from "rxjs";
import { AdminPanelMenu } from "./admin-panel/admin-panel-menu";
import { AuthService } from "./auth/auth.service";
import { ClientPanelMenu } from "./client-panel/client-panel-menu";
import { AbstractMenuModule } from "./menu/abstract-menu-module";
import { MainMenuService } from "./menu/main-menu.service";
import { StoragePanelMenu } from "./storage-panel/storage-panel-menu";
import { AppMenu } from "./app-menu";
import { environment } from "../environments/environment";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'app';
  version = environment.version

  constructor(private auth: AuthService, private menuService: MainMenuService, private router: Router) {
    // Adding a menu modules, a new menu modules should be added here
    this.menuService.addMenuModule(new AppMenu(this.auth, this.router));
    this.menuService.addMenuModule(new AdminPanelMenu);
    this.menuService.addMenuModule(new ClientPanelMenu);
    this.menuService.addMenuModule(new StoragePanelMenu);
    
    // subscribe to the NavigationEnd router events. And update the menu each time after routing is changed
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(async (e) => {
      await menuService.buildMenu();
    });
  }

}
